import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../../app.service';
import { SafetyInductionService } from '../services/safety-induction.service';
import { InductionQuestionsVM, InductionSlides, PerformInductionVM } from '../setup-induction-question/setup-induction-question';

@Component({
  selector: 'app-start-induction',
  templateUrl: './start-induction.component.html',
  styleUrls: ['./start-induction.component.css']
})
export class StartInductionComponent implements OnInit {

  InductionId: number = 0;
  SelectionName: string;
  SlideList: InductionSlides[];
  CompletedSectionIDs: number[];
  SelectedSlide: InductionSlides;
  ShowNextBtn: boolean;
  ShowBackBtn: boolean;
  SlideImage: string;
  ShowSectionQuestions: boolean;
  multiplechoiceArray: InductionQuestionsVM[];
  multiplselectionArray: InductionQuestionsVM[];
  trueFalseArray: InductionQuestionsVM[];
  ShowInvalidSlide: boolean = false;
  ShowNextSectionBtn: boolean = false;
  ShowInvalidBanner: boolean = false;
  loading: boolean = false;
  ResultStartInduction: PerformInductionVM;
  ShowSectionQuestionButton: boolean = true;
  ShowCompleteMessage: boolean = false;


  constructor(private _router: Router,
    private _appService: AppService,
    private _inductionService: SafetyInductionService,
    public dialog: MatDialog,
    private _sanitizer: DomSanitizer,private _route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.loading = true;
    this._appService.setPageTitle('Mainetec Induction');
    //this._appService.setPageSubTitle('');

    this.InductionId = +this._route.snapshot.paramMap.get('InductionId');

    this._inductionService.StartInduction(this.InductionId).subscribe(res => {
      console.log("StartInduction", res)
      if (res.m_Item1) {
        this.ResultStartInduction = res.m_Item2

        this._inductionService.GetSlidesInfo(this.InductionId).subscribe(res => {

          if (res.length > 0) {

            res.map(m => {
              let temp = m.VideoUrl
              m.VideoUrl = temp ? `https://www.youtube.com/embed/${temp}` : temp
            })


            //check for section question
            let allQuestions = this.ResultStartInduction.Questions.filter(f => f.SlideSelectionId == res[0].SlideSelectionId)
            if (allQuestions && allQuestions.length > 0) {
              this.ShowSectionQuestionButton = true
            } else {
              this.ShowSectionQuestionButton = false
            }


            this.SlideList = res
            this.SelectedSlide = res[0]
            this.SlideImage = res[0].SlideImg

            let currentSlide = this.SelectedSlide

            let selectedIndex = this.SlideList.findIndex(f => f.ID == currentSlide.ID)

            let PrevSlide = this.SlideList[selectedIndex - 1]
            let NextSlide = this.SlideList[selectedIndex + 1]


            if (PrevSlide) {
              this.ShowBackBtn = true
            } else {
              this.ShowBackBtn = false

            }

            if (NextSlide) {
              this.ShowNextBtn = true
            } else {
              this.ShowNextBtn = false
            }


          }
          this.loading = false;
        })

      }
    })



  }

  getDate() {
    return new Date(this.ResultStartInduction.InductionInfo.date).toLocaleString("en-us", {
      month: "long",
      year: "numeric",
      day: "numeric"
    })
  }

  getImage(image: string) {
    // return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);

  }

  getVideo(url: string) {
    // return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    return this._sanitizer.bypassSecurityTrustResourceUrl(url);

  }

  onClickBack() {
    let currentSlide = this.SelectedSlide

    let selectedIndex = this.SlideList.findIndex(f => f.ID == currentSlide.ID)

    let PrevSlide = this.SlideList[selectedIndex - 1]

    if (PrevSlide) {
      this.SelectedSlide = new InductionSlides();
      this.SelectedSlide = this.SlideList[selectedIndex - 1]
      this.loading = true
      this._inductionService.GetImageBase64Data(PrevSlide.ID).subscribe(res => {
        if (res) {
          this.SlideImage = res

        } else {
          this.SlideImage = ""
        }
        this.loading = false
      })
    }

    //check show back button
    let checkBackBtnShow = this.SlideList[selectedIndex - 2]
    if (checkBackBtnShow && checkBackBtnShow.SlideSelectionId==currentSlide.SlideSelectionId) {
      this.ShowBackBtn = true
      this.ShowNextBtn = true
    } else {
      this.ShowBackBtn = false
      this.ShowNextBtn = true
    }


  }

  onClickNext() {
    let currentSlide = this.SelectedSlide

    let selectedIndex = this.SlideList.findIndex(f => f.ID == currentSlide.ID)

    let NextSlide = this.SlideList[selectedIndex + 1]




    if (NextSlide && (NextSlide.SlideSelectionId != currentSlide.SlideSelectionId)) {
      this.onClickShowNextSection()

    } else {
      if (NextSlide) {

        this.SelectedSlide = new InductionSlides();
        this.SelectedSlide = NextSlide
        this.loading = true
        this._inductionService.GetImageBase64Data(NextSlide.ID).subscribe(res => {
          if (res) {
            this.SlideImage = res

          } else {
            this.SlideImage = ""
          }

          this.loading = false
        })

      } else {
        console.log("NoSlides")
        this._showCompleteMessage();
      }

      //check show next button
      this.EnableNextButton(selectedIndex, currentSlide, 2);
    }



  }

  EnableNextButton(selectedIndex, currentSlide, numberToCheckNext) {
    let checkNextBtnShow = this.SlideList[selectedIndex + numberToCheckNext]

    if (checkNextBtnShow && checkNextBtnShow.SlideSelectionId == currentSlide.SlideSelectionId) {
      this.ShowBackBtn = true
      this.ShowNextBtn = true
    } else {
      this.ShowBackBtn = true
      this.ShowNextBtn = false
    }

    if (this.ShowSectionQuestionButton == false && checkNextBtnShow) {

      this.ShowNextBtn = true
    }

    //hide back button on new section
    if (numberToCheckNext == 1) {
      this.ShowBackBtn = false
    }

    if(!checkNextBtnShow && this.ShowSectionQuestionButton == false){
      this.ShowNextBtn = true
    }

  }

  ClickStartSectionQuestion() {
    this.ShowNextSectionBtn = false;
    if (this.ShowInvalidSlide == false) {
      this.loading = true;
      this._inductionService.GetQuestionsAnswersForSection(this.SelectedSlide.SlideSelectionId).subscribe(res => {

        console.log("GetQuestionsAnswersForSection", res)
        this.ShowSectionQuestions = true
        let _multiplechoiceArray = []
        let _multiplselectionArray = []
        let _trueFalseArray = []


        for (var i = 0; i < res.length; i++) {
          if (res[i].QuestionTypeId == 2) {
            _multiplechoiceArray.push(res[i]);

          }
          else if (res[i].QuestionTypeId == 3) {
            _multiplselectionArray.push(res[i]);

          } else if (res[i].QuestionTypeId == 1) {
            _trueFalseArray.push(res[i]);

          }
        }
        this.multiplechoiceArray = _multiplechoiceArray;
        this.multiplselectionArray = _multiplselectionArray
        this.trueFalseArray = _trueFalseArray;
        this.loading = false

        // if (multiplechoiceArray.length > 0) {
        //   CreateMultipleChoiceQuestion(multiplechoiceArray);
        // }
        // if (multiplselectionArray.length > 0) {
        //   CreateMultipleSelectionQuestion(multiplselectionArray)
        // }
        // if (trueFalseArray.length > 0) {
        //   CreateTrueFalseQuestion(trueFalseArray);
        // }
      })
    } else {
      this.ShowSectionQuestions = true
      this.ShowInvalidSlide = false
    }
  }

  ChangeMCAnswer(ans) {
    let arrq = this.multiplechoiceArray
    arrq.map(a => {
      if (a.Id == ans.Qid) {
        a.AnswerList.map(aa => {
          if (aa.Id == ans.Id) {
            aa.userSelectAnswer = true
          } else {
            aa.userSelectAnswer = false
          }
        })
      }
    })

    this.multiplechoiceArray = arrq
  }

  ChangeMSAnswer(ans) {
    let arrq = this.multiplselectionArray
    arrq.map(a => {
      if (a.Id == ans.Qid) {
        a.AnswerList.map(aa => {
          if (aa.Id == ans.Id) {
            aa.userSelectAnswer = !aa.userSelectAnswer
          }
        })
      }
    })

    this.multiplselectionArray = arrq

  }

  ChangeTFAnswer(ans) {
    let arrq = this.trueFalseArray
    arrq.map(a => {
      if (a.Id == ans.Qid) {
        a.AnswerList.map(aa => {
          if (aa.Id == ans.Id) {
            aa.userSelectAnswer = true
          } else {
            aa.userSelectAnswer = false
          }
        })
      }
    })

    this.trueFalseArray = arrq

    console.log("this.trueFalseArray", this.trueFalseArray)
  }

  onClickSubmit() {
    let _multiplselectionArray = this.multiplselectionArray
    let _multiplechoiceArray = this.multiplechoiceArray
    let _trueFalseArray = this.trueFalseArray

    _multiplselectionArray.map(y => {
      var onevalidfalse = false;
      if (y.QuestionTypeId == 3) {
        var count = 0;
        var selectall = false;
        var correctAns = y.CorrectAns;

        var countList = y.AnswerList.map(a => {



          if (a.correct == true) {
            if (a.userSelectAnswer == true) {
              count = count + 1;

            }
          }
          if (a.correct == false) {
            if (a.userSelectAnswer == true) {
              y.valid = false;
              onevalidfalse = true;
              selectall = true;
            }

          }


        })

        if (selectall == false) {
          if (count < correctAns) {
            y.valid = false;
            onevalidfalse = true;
          } else {
            onevalidfalse = true;
            y.valid = true;
          }
        }

      }
    })

    _multiplechoiceArray.map(y => {
      var onevalidfalse = false;
      var correct_ans_check = y.AnswerList.find(f => f.correct != f.userSelectAnswer)

      if (correct_ans_check) {
        if (y.Id == correct_ans_check.Qid) {
          onevalidfalse = true;
          y.valid = false;

        }

      } else {

        onevalidfalse = true;
        y.valid = true;
      }
    })

    _trueFalseArray.map(y => {
      var onevalidfalse = false;
      var correct_ans_check = y.AnswerList.find(f => f.correct != f.userSelectAnswer)
      console.log("correct_ans_check", correct_ans_check)
      if (correct_ans_check) {
        if (y.Id == correct_ans_check.Qid) {
          onevalidfalse = true;
          y.valid = false;

        }

      } else {

        onevalidfalse = true;
        y.valid = true;
      }
    })


    this.multiplechoiceArray = _multiplechoiceArray;
    this.multiplselectionArray = _multiplselectionArray
    this.trueFalseArray = _trueFalseArray;

    //check for invalid question
    let _invalidQ = [..._multiplechoiceArray, ..._multiplselectionArray, ..._trueFalseArray]

    let checkInvalid = _invalidQ.find(f => !f.valid)
    console.log("checkInvalid", checkInvalid)
    if (checkInvalid) {
      this.ShowNextSectionBtn = false
      this.ShowInvalidBanner = true
    } else {
      this.ShowNextSectionBtn = true
      this.ShowInvalidBanner = false
    }

  }

  _showCompleteMessage() {
    this.ShowCompleteMessage = true
    this.ShowSectionQuestions = false
  }

  onClickShowNextSection() {


    let _completedSectionIds = this.CompletedSectionIDs ? this.CompletedSectionIDs : []
    _completedSectionIds.push(this.SelectedSlide.SlideSelectionId)
    this.CompletedSectionIDs = _completedSectionIds;

    //check all sections answrd
    let checkCompleted=true
    for (var i = 0; i < this.ResultStartInduction.Selections.length; ++i) {
      let m = this.ResultStartInduction.Selections[i]
      let check = _completedSectionIds.find(f => f == m.ID)

      if(!check){
        checkCompleted=false
        break;
      }
    }

    if(checkCompleted){
      this._showCompleteMessage()
      return
    }


    //get completed slides using section id
    let nextSlideSectionId = 0;
    for (var i = 0; i < this.SlideList.length; ++i) {

      let m = this.SlideList[i]

      let checkCompletedSlide = _completedSectionIds.find(f => f == m.SlideSelectionId)

      if (!checkCompletedSlide) {

        nextSlideSectionId = m.SlideSelectionId
        this.SelectedSlide = m
        this._inductionService.GetImageBase64Data(m.ID).subscribe(res => {
          if (res) {
            this.SlideImage = res

          } else {
            this.SlideImage = ""
          }

          this.loading = false
        })
        this.ShowInvalidSlide = false;
        this.ShowSectionQuestions = false
        this.ShowNextSectionBtn = false;

        //check for section question
        let allQuestions = this.ResultStartInduction.Questions.filter(f => f.SlideSelectionId == nextSlideSectionId)
        if (allQuestions && allQuestions.length > 0) {
          this.ShowSectionQuestionButton = true
        } else {
          this.ShowSectionQuestionButton = false
        }

        this.EnableNextButton(i, m, 1)
        break;
      }
    }

  }

  ClickQuestionWarning(question) {
    console.log("question", question)
    this.ShowInvalidSlide = true
    let slide = this.SlideList.find(f => f.ID == question.InductionSlideId)
    this.SelectedSlide = slide

    this._inductionService.GetImageBase64Data(slide.ID).subscribe(res => {
      if (res) {
        this.SlideImage = res

      } else {
        this.SlideImage = ""
      }

      this.loading = false
    })

    this.ShowSectionQuestions = false

  }

  OnClickDone(){
    
    this._router.navigate(['/safety/home']);
  }

}
